
import { Referral } from '@/components/ReferralList';

// Updated interface to include points property
export interface ReferralWithPoints extends Referral {
  points: number;
}

// Mock data for referrals
const referrals: ReferralWithPoints[] = [
  {
    id: '1',
    name: 'Alice Smith',
    email: 'alice@example.com',
    status: 'pending',
    date: new Date('2023-03-15').toISOString(),
    points: 10
  },
  {
    id: '2',
    name: 'Bob Johnson',
    email: 'bob@example.com',
    status: 'approved',
    date: new Date('2023-03-10').toISOString(),
    points: 10
  },
  {
    id: '3',
    name: 'Sarah Wilson',
    email: 'sarah@example.com',
    status: 'rejected',
    date: new Date('2023-03-05').toISOString(),
    points: 0
  }
];

export const getAllReferrals = (): Promise<ReferralWithPoints[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([...referrals]);
    }, 800);
  });
};

export const approveReferral = async (referralId: string): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const referralIndex = referrals.findIndex(r => r.id === referralId);
      if (referralIndex >= 0) {
        referrals[referralIndex] = {
          ...referrals[referralIndex],
          status: 'approved'
        };
      }
      resolve();
    }, 1000);
  });
};

export const rejectReferral = async (referralId: string): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const referralIndex = referrals.findIndex(r => r.id === referralId);
      if (referralIndex >= 0) {
        referrals[referralIndex] = {
          ...referrals[referralIndex],
          status: 'rejected'
        };
      }
      resolve();
    }, 1000);
  });
};
